import axios from "axios";
import { API_URL } from "../const/api";

export const guardarIdioma = (lang) => {
  localStorage.setItem(`lang`, JSON.stringify(lang));
}
export const getIdioma = () => {
  if(localStorage.getItem('lang') === null) {
    guardarIdioma('es');
    return 'es';
  } 
  return JSON.parse(localStorage.getItem('lang'));
}

export const guardarFavorito = (id_fav, user) => {
  if(!user) user='global';
  let favoritos;
  if(localStorage.getItem(`fav${user}`) === null) {
      favoritos = [];
  } else {    
      favoritos = JSON.parse(localStorage.getItem(`fav${user}`))   
  }
  favoritos.push(id_fav);
  localStorage.setItem(`fav${user}`, JSON.stringify(favoritos));
}

export const eliminarFavorito = (id_fav, user) => {
  if(!user) user='global';
  let favoritos;
  if(localStorage.getItem(`fav${user}`) === null) {
      favoritos = [];
  } else {  
      favoritos = JSON.parse(localStorage.getItem(`fav${user}`))
  }

  for(let x in favoritos) {
      if(favoritos[x] === id_fav) {
        favoritos.splice(x,1)
      }
  }
  localStorage.setItem(`fav${user}`, JSON.stringify(favoritos))
}

export const verificarFavorito = (id_fav, user) => {
  if(!user) user='global';
  let favoritos;
  if(localStorage.getItem(`fav${user}`) === null) {
      favoritos = [];
      return false;
  } else {
    favoritos = JSON.parse(localStorage.getItem(`fav${user}`))
  }
  if(favoritos.includes(id_fav)) {
    return true;
  } else {
    return false;
  }
}

export const setId = async (id, moneda) => {
  const res = await axios.post(API_URL+'guardar', {a:id,b:moneda});
  localStorage.setItem('MBC', JSON.stringify(res.data.aenc));
  localStorage.setItem('MBD', JSON.stringify(res.data.benc));
}

export const getId = async () => {
  let id;
  let moneda;
  if((localStorage.getItem('MBC') === null) || (localStorage.getItem('MBD') === null)) {
    return false;
  } 
  id = JSON.parse(localStorage.getItem('MBC'));
  moneda = JSON.parse(localStorage.getItem('MBD'));

  const res = await axios.post(API_URL+'mostrar', {a:id,b:moneda});
  return res.data;
}

//casino

export const guardarFavoritoCasino = (id_fav, user) => {
  let favoritos;
  if(localStorage.getItem(`favc${user}`) === null) {
      favoritos = [];
  } else {    
      favoritos = JSON.parse(localStorage.getItem(`favc${user}`))   
  }
  favoritos.push(id_fav);
  localStorage.setItem(`favc${user}`, JSON.stringify(favoritos));
}

export const eliminarFavoritoCasino = (id_fav, user) => {
  let favoritos;
  if(localStorage.getItem(`favc${user}`) === null) {
      favoritos = [];
  } else {  
      favoritos = JSON.parse(localStorage.getItem(`favc${user}`))
  }

  for(let x in favoritos) {
      if(favoritos[x] === id_fav) {
        favoritos.splice(x,1)
      }
  }
  localStorage.setItem(`favc${user}`, JSON.stringify(favoritos))
}

export const verificarFavoritoCasino = (id_fav, user) => {
  let favoritos;
  if(localStorage.getItem(`favc${user}`) === null) {
      favoritos = [];
      return false;
  } else {
    favoritos = JSON.parse(localStorage.getItem(`favc${user}`))
  }
  if(favoritos.includes(id_fav)) {
    return true;
  } else {
    return false;
  }
}